import { ReactElement } from 'react'

import { Select, Spin } from 'antd'

import { getSovKeywords } from 'api/Cerebro/orgScoped/shareOfVoiceApi'
import { SEARCH_RESULTS_PER_QUERY } from 'configuration/typeahead'
import { formatSovKeywordLabel } from 'helpers/formatting'
import { useTypeahead } from 'hooks'
import { SovKeyword } from 'types'

interface Props {
    value?: string
    onChange: (value: string) => void
}

const SovKeywordSearchSelect = ({ value, onChange }: Props): ReactElement => {
    const [options, loading, onSearch, resetLoadingState] =
        useTypeahead<SovKeyword>({
            apiSearchFunc: (query) =>
                getSovKeywords(
                    {
                        limit: SEARCH_RESULTS_PER_QUERY,
                        text__similar: query,
                    },
                    { headers: { noCount: true } }
                ),
            optionFormatter: (keyword) => ({
                value: keyword.id,
                label: formatSovKeywordLabel(keyword),
            }),
        })

    return (
        <Select
            filterOption={false}
            placeholder="Search SOV Keywords..."
            loading={loading}
            notFoundContent={loading ? <Spin size="small" /> : null}
            onChange={onChange}
            onSearch={onSearch}
            onSelect={resetLoadingState}
            showSearch
            style={{ width: '100%' }}
            value={value}
        >
            {options.map((option) => (
                <Select.Option key={option.value} value={option.value}>
                    {option.label}
                </Select.Option>
            ))}
        </Select>
    )
}

export default SovKeywordSearchSelect
